import { isMobile } from "../mobile-check";

// Login / Forgotten password toggle
$(".forgotten-pass, .loginfrom-link").on("click", function(e) {
  e.preventDefault();
  const $this = $(this);
  const targetString = $this.attr("href").replace("#", "");
  $(`.${targetString}`).show();
  $this
    .closest("form")
    .parent()
    .hide();
});

// Address new
$(".addresses__actions .btn--new, .form--address-new .btn--cancel").on(
  "click",
  function(e) {
    e.preventDefault();
    const $this = $(this);
    const targetString = $this.attr("href").replace("#", "");
    $(`.${targetString}`).toggle();
  }
);

// Collection sortBy
$("#sortBy").on("change", function() {
  Shopify.queryParams = {};
  const $this = $(this);
  const thisVal = $this.val();

  if (location.search) {
    const getArgumentsArray = location.search.substr(1).split("&");
    getArgumentsArray.map(function(ele) {
      const eleArray = ele.split("=");
      Shopify.queryParams[decodeURIComponent(eleArray[0])] = decodeURIComponent(
        eleArray[1]
      );
    });
  }

  Shopify.queryParams.sort_by = thisVal;
  location.search = jQuery.param(Shopify.queryParams);
});

// Product price update
$(".product-single__variants").on("change", function() {
  const $this = $(this);
  const $option = $this.find("option:selected");
  const $btnSubmit = $this
    .closest("form")
    .find('input[type="submit"], button[type="submit"]');
  const thisPrice = $this.find("option:selected").data("price");

  $(".product__price").html(thisPrice);

  if ($option.is(":disabled")) {
    $btnSubmit
      .html(Shopify.theme.locale.products.product.sold_out)
      .prop("disabled", true);
  } else {
    $btnSubmit
      .html(Shopify.theme.locale.products.product.add_to_cart)
      .prop("disabled", false);
  }
});

// Address province option
$('select[name="address[country]"]').each(function() {
  const $this = $(this);
  const thisID = $this.attr("id");
  const province = $this
    .closest("form")
    .find('select[name="address[province]"]');
  const provinceID = province.attr("id");
  const provinceHolderID = province.closest(".form__row").attr("id");
  new Shopify.CountryProvinceSelector(thisID, provinceID, {
    hideElement: provinceHolderID
  });
});

if (isMobile()) {
  $("body").addClass("is-mobile");
}
